import{__rest as e}from'./../../ext/tslib/tslib.es6.js';function o(o,t){var a=o.elevation,i=e(o,["elevation"]);return void 0!==a&&(i.boxShadow=t.elevations[parseFloat(a)-1]),i}export{o as default};
//# sourceMappingURL=elevation.js.map
